import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { GetNetSuiteBillPaymentBills } from 'shared/data/webApp/v2';

import { NetSuiteCreditListLineExpanded } from '../data/types';
import { SelectableBillItem } from './NetSuiteBillPaymentRequestForm.types';

export const netSuiteBillPaymentCreditListState = atomWithReset<NetSuiteCreditListLineExpanded[]>([]);

export const netSuiteBillPaymentBillsFilterTransferState = atomWithReset<
    Partial<GetNetSuiteBillPaymentBills['params']['query']>
>({});

export const netSuiteBillPaymentSelectableBillsState = atomWithReset<SelectableBillItem[]>([]);

export const netSuiteBillPaymentShowPopupErrorsState = atom<boolean>(false);

export const netSuiteBillPaymentApplyListRequestIdsWithStatusErrorState = atom<string[]>([]);

export const netSuiteBillPaymentApplyListRequestIdsWithPaymentErrorState = atom<string[]>([]);
